import { EnergyFeedbackType } from '@demind-inc/core';
import { EnergyLevelType } from '../../data-access';
import { getCssVariable } from '../../utils';
import { CustomTooltipContentProps } from '../common';

const COLOR_RED = getCssVariable('--color-red-base') || '#f34720';
const COLOR_GREEN = getCssVariable('--color-green-base') || '#09c25a';
const COLOR_YELLOW = getCssVariable('--color-yellow-base') || '#fdc913';
const COLOR_BLUE = getCssVariable('--color-blue-base') || '#3a92fa';

export const energyFeedbackLabelSet: EnergyFeedbackType[] = [
  'low',
  'mild',
  'medium',
  'strong',
  'high',
];

// @link: https://www.notion.so/demind-inc/Feature-Title-options-on-the-Popup-on-home-view-c3f12774416a46298da069c87fb039ee
export const energyBarSet: Record<
  EnergyLevelType,
  { color: string; text: string; action: string }
> = {
  low: {
    color: COLOR_RED,
    text: 'Low Energy',
    action: 'Time for energy boosts',
  },
  normal: {
    color: COLOR_YELLOW,
    text: 'Medium Energy',
    action: 'Time for easy tasks',
  },
  high: {
    color: COLOR_GREEN,
    text: 'High Energy',
    action: 'Time for demanding tasks',
  },
  sleep: {
    color: COLOR_BLUE,
    text: 'Sleep',
    action: 'Good night :)',
  },
  wind_down: {
    color: COLOR_RED,
    text: 'Wind Down',
    action: 'Time for relaxing activities',
  },
};

export const circadianTooltipInfo: CustomTooltipContentProps = {
  title: '⚡️ Energy',
  description:
    'Your Energy Score predicts your energy from 0 to 100 using sleep data and circadian rhythm patterns. Higher wave points mean higher predicted energy, which is often a better time for demanding work. Event categories and your check-ins fine-tune the wave.',
  learnMoreLink:
    'https://demind-inc.notion.site/Understanding-Your-Energy-Score-26f7c97113e680c7b0a4c1fc75e21cc8',
  referenceLinkList: [
    {
      title: 'Overview of Circadian Rhythms',
      url: 'https://www.uptodate.com/contents/overview-of-circadian-rhythm-sleep-wake-disorders',
    },
    {
      title: 'Physiology, Circadian Rhythm',
      url: 'https://www.ncbi.nlm.nih.gov/books/NBK519507/',
    },
  ],
};
